import Link from 'next/link'
import styled from 'styled-components'

export const SectionWrap = styled.div`
  position: relative;
  overflow: hidden;
`
export const WaveDividerWrap = styled.div`
  > div {
    height: 90%;
    width: 150%;
  }
  @media (max-width: 768px) {
    > div {
      height: 30% !important;
    }
  }
`
export const Content = styled.div`
  position: relative;
  z-index: 2;
  @media (max-width: 1099px) {
    overflow: hidden;
  }
`
export const TitleWrapper = styled.div`
  & > h2 {
    position: relative;
    width: fit-content;
    margin: 0 auto;
  }

  & svg {
    position: absolute;
    bottom: -12px;
    left: 0;
  }

  @media (max-width: 768px) {
    & > h2 {
      width: 100%;
    }
    & svg {
      bottom: -6px;
      width: 46px;
      height: 4px;
    }
  }
`
export const Tile = styled(Link)`
  color: var(--brand-secondary);
  text-decoration: none;
`
export const Stories = styled.div`
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  column-gap: 100px;

  & > a:nth-child(2) {
    margin-top: 120px;
  }

  @media (max-width: 900px) {
    & > a:nth-child(2) {
      margin-top: 0;
    }
  }

  @media (max-width: 768px) {
    gap: 24px;
    padding-bottom: 20px;
  }
`
export const StoriesSwiper = styled.div`
  @media (min-width: 1100px) {
    padding-bottom: 70px;

    .swiper {
      overflow: visible;
    }
    .swiper-slide:nth-child(2) {
      position: relative;
      top: 70px;
    }
  }

  @media (max-width: 1099px) {
    width: 100vw;
    left: -100px;
    box-sizing: border-box;
    position: relative;

    .story-swiper-tile {
      width: 40vw;
    }

    .swiper {
      padding: 20px 25px;
    }
  }
  @media (max-width: 768px) {
    left: -25px;
  }
`
export const StoryImage = styled.div<{ image: string }>`
  background-color: lightgrey;
  background-image: ${({ image }) => `url(${image})`};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 490px;
  border-radius: 20px;
  margin-bottom: 16px;

  @media (max-width: 1100px) {
    height: 350px;
  }

  @media (max-width: 900px) {
    height: 220px;
  }
`
